import {$, T} from "../../common/drupal/drupal";

class AgeRate {

  /**
   * Initialize event listeners
   */
  init() {


    // Checkout cookie.
    let valid = Cookies.get('lmb-age-rate');

    if (valid != 1) {
      $('#age-rate.Popin').addClass('open');
      $('#age-rate.Popin .forbidden').hide();
    }

    // Attach click event.
    $('#age-rate.Popin .yes').once().click(function () {
      Cookies.set('lmb-age-rate', 1);
      $('#age-rate.Popin').removeClass('open');
    });
    $('#age-rate.Popin .no').once().click(function () {
      Cookies.set('lmb-age-rate', 0);
      $('#age-rate.Popin .intro').hide();
      $('#age-rate.Popin .forbidden').show();
    });
    $('#age-rate.Popin .back').once().click(function () {
      $('#age-rate.Popin .intro').show();
      $('#age-rate.Popin .forbidden').hide();
    });
  }

  attach(context) {
    if (T.contextIsRoot(context)) {
      this.init(context);
    }
  }
}

export let ageRate = new AgeRate();
